
import React, { useRef, useLayoutEffect } from 'react'

// components
import {
  CInputGroup,
  CCol,
  CInputGroupText,
  CRow,
  CFormLabel,
  CFormInput
} from '@coreui/react-pro'

// helper
import { formatPrice, findIndexByDigitCount } from 'src/helpers/format-number'

const FormPrice = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  placeholder,
  value,
  handlePriceInput,
  feedbackInvalid,
  invalid,
  combinationIndex,
  disabled
}) => {
  const inputRef = useRef(null)
  const caretDigitsRef = useRef(null)

  const handleChange = (e) => {
    // Ambil posisi kursor sebelum format ulang
    const cursorPos = (typeof e.target.selectionStart === 'number') ? e.target.selectionStart : null
    const leftSlice = cursorPos != null ? e.target.value.slice(0, cursorPos) : ''
    const digitsLeft = (leftSlice.match(/\d/g) || []).length
    caretDigitsRef.current = digitsLeft

    // Panggil handler parent (biar dia yang atur value ke state/formik)
    handlePriceInput(e, combinationIndex)
  }

  // Setelah value berubah, set kembali caret ke posisi yang benar
  useLayoutEffect(() => {
    const digitsWanted = caretDigitsRef.current
    if (digitsWanted == null) return

    const formatted = value ? formatPrice(value) : ''
    const newPos = findIndexByDigitCount(formatted, digitsWanted)

    const inputEl = inputRef.current || (id ? document.getElementById(id) : null)
    if (inputEl && typeof inputEl.setSelectionRange === 'function') {
      try {
        inputEl.setSelectionRange(newPos, newPos)
      } catch (_) {}
    }

    caretDigitsRef.current = null
  }, [value, id])

  return (
    <CCol lg={colSize} className={className}>
      {
        inputLabel && (
          <CFormLabel>
            {inputLabel}
          </CFormLabel>
        )
      }
      <CRow>
        <CInputGroup>
          <CInputGroupText>IDR</CInputGroupText>
          <CFormInput
            id={id}
            name={name}
            placeholder={placeholder}
            type="text"
            value={value ? formatPrice(value) : ''}
            onChange={handleChange}
            feedbackInvalid={feedbackInvalid}
            invalid={invalid}
            disabled={disabled}
          />
        </CInputGroup>
      </CRow>
    </CCol>
  )
}

export default FormPrice
